import { type Ref } from 'react';
import { Button, Icon, Modal, SoundToggle } from '@/ui/components/base';
import { parentApi } from '@/ui/lib/parentApi';
import gameIcon from '@/assets/icons/game.svg';
import historyIcon from '@/assets/icons/game-history.svg';
import exitIcon from '@/assets/icons/exit.svg';
import { MenuItem } from './MenuItem/MenuItem';
import type { MenuItem as MenuItemType } from '../Menu';
import './MainMenu.css';

interface MainMenuProps {
    onNavigate: (item: MenuItemType) => void;
    ref?: Ref<HTMLDivElement>;
}

export const MainMenu = ({ ref, onNavigate }: MainMenuProps) => {
    return (
        <Modal.Content className="main-menu" gap="lg" ref={ref}>
            <Modal.Header>Goosicorn Racing</Modal.Header>
            <Modal.Body>
                <div className="main-menu__body">
                    <MenuItem icon={gameIcon} onClick={() => onNavigate('gameRules')}>
                        Game rules
                    </MenuItem>

                    <MenuItem icon={historyIcon} onClick={() => onNavigate('playHistory')}>
                        Play history
                    </MenuItem>

                    <div className="main-menu__actions">
                        <Button
                            className="main-menu__exit-button"
                            variant="ghost"
                            onClick={parentApi.quitGame}
                        >
                            <Icon src={exitIcon} />
                            Exit game
                        </Button>
                        <SoundToggle />
                    </div>
                </div>
            </Modal.Body>
        </Modal.Content>
    );
};
